import { render, staticRenderFns } from "./RegisterState.vue?vue&type=template&id=1f711152&scoped=true&"
import script from "./RegisterState.vue?vue&type=script&lang=ts&"
export * from "./RegisterState.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterState.vue?vue&type=style&index=0&id=1f711152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f711152",
  null
  
)

export default component.exports